import Toast from '../Toast';
import { ApiResponse, PaginatedApiResponse, axios } from '../config/axios';
import config from '../config/config';

export const QuotesService = {
  async all({ per_page, page, search, bookId }: any): Promise<PaginatedApiResponse<any>> {
    return await axios.get('/quotes', {
      params: {
        per_page,
        page,
        search,
        book_id: bookId,
      },
    });
  },
  async one(id: number | string): Promise<ApiResponse<any>> {
    return await axios.get(`/quotes/${id}`);
  },
  async create(data: any) {
    let response;
    try {
      await axios.post(`${config.baseUrl}/quotes`, data);
      response = { success: true, response };
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
      response = { success: false, error };
    }
    return response;
  },
  async update(id: number, data: { name: string }) {
    try {
      const response = await axios.patch(`${config.baseUrl}/quotes/${id}`, data);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async delete(id: number) {
    try {
      const response = await axios.delete(`${config.baseUrl}/quotes/${id}`);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
};

export default QuotesService;
